import React from 'react';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { symbolInfoStreamedDataSelectors } from 'widgets/symbolInfo/store/streamSlice';
import { SymbolInfoCapsuleConfigState } from 'widgets/symbolInfo/capsule/store/config/SymbolInfoCapsuleConfigState';
import { SymbolInfoCapsuleContent } from 'widgets/symbolInfo/capsule/SymbolInfoCapsuleContent';

const { useSymbolStreamedData } = symbolInfoStreamedDataSelectors;

export function SymbolInfoCapsuleMyPortfolioCapsuleContent(
    props: MyPortfolioCapsuleContentProps
) {
    const { symbol } = props;
    const { config } =
        useMyPortfolioCapsuleConfigSlice<SymbolInfoCapsuleConfigState>();

    const data = useSymbolStreamedData(symbol, config);

    return <SymbolInfoCapsuleContent data={data} />;
}
